module.exports = __webpack_public_path__ + "img/small3-cn.1fa74987.png";